import * as React from 'react'

import { WeightInput } from 'modules/performance_process/components/score_configuration_weights/ScoreWeightsSidepanel/WeightInput'
import { getQuestionnaireTranslations } from 'modules/performance_process/lib/questionnaireForStrategies'
import Section from 'modules/questionnaires/components/Section'
import type { Section as SectionType } from 'modules/questionnaires/lib/types'

type Props = {
  section: SectionType
  weight?: number | null
  weightable?: boolean
  onChange: (sectionId: string, weight: number) => void
}

export const SectionWeightItem: React.FC<Props> = ({
  section,
  weight,
  weightable = false,
  onChange,
}) => {
  const handleChange = (value: number | null) => {
    const newWeight = value ?? 0
    onChange(section.uuid, newWeight)
  }

  const renderSectionHeader = () => {
    return <WeightInput value={weight} onChange={handleChange} weightable={weightable} />
  }

  return (
    <Section
      disabled
      collapsed
      hideQuestionTypes
      translations={getQuestionnaireTranslations()}
      editing={false}
      section={section}
      locked
      hideLockedIcon
      renderHeaderAddon={renderSectionHeader}
    />
  )
}
